import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import KnowledgeBaseLayout from './KnowledgeBaseLayout';
import { KnowledgeBaseGroupCard } from './KnowledgeBaseCards';
import { fetchPublicKnowledgeBase } from './knowledgeBaseApi';
import { KnowledgeBaseGroup, KNOWLEDGE_BASE_PUBLIC_PATH } from './KnowledgeBaseTypes';

// The home page of the public knowledge base with the search bar and the group cards
const KnowledgeBasePage: React.FC = () => {
    const { t } = useTranslation();
    const history = useHistory();
    const [groups, setGroups] = useState<KnowledgeBaseGroup[]>([]);
    const [loaded, setLoaded] = useState(false);

    // Fetch the groups
    useEffect(() => {
        fetchPublicKnowledgeBase<{ groups: KnowledgeBaseGroup[] }>('get_public_knowledge_base')
            .then(data => setGroups(data.groups))
            .catch(() => setGroups([]))
            .finally(() => setLoaded(true));
    }, []);

    return (
        <KnowledgeBaseLayout hero={true} width='narrow'>
            <div className='kb-card-list kb-group-list'>
                {groups.map(group => (
                    <KnowledgeBaseGroupCard
                        key={group.id}
                        group={group}
                        onClick={() => history.push(`${KNOWLEDGE_BASE_PUBLIC_PATH}/groep/${group.id}`)} />
                ))}
            </div>
            {loaded && groups.length === 0 && <div className='kb-empty-state'>{t('knowledge_base.public.no_groups')}</div>}
        </KnowledgeBaseLayout>
    );
};

export default KnowledgeBasePage;
